<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>设备详情</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="content-wrapper">
         <div class="detail-title">设备状态</div>
         <DeviceStatus :uid="deviceUid"></DeviceStatus>
      </div>

      <div class="content-wrapper">
         <div class="detail-title title-margin">坐位体前屈设备</div>
         <el-table :data="upgradeList" border style="width: 100%;">
            <el-table-column align="center" label="序号" width="80" type="index"></el-table-column>
            <el-table-column align="center" label="设备类型" prop="deviceType"></el-table-column>
            <el-table-column align="center" label="当前版本" prop="versionCode"> </el-table-column>
            <el-table-column align="center" label="更新日期" prop="updateTime"></el-table-column>
            <el-table-column align="center" label="最近配置的更新" prop="lastVersionCode"></el-table-column>
            <el-table-column align="center" label="操作" width="100">
               <template scope="{ row }">
                  <el-button type="text" size="small" @click="clickUpdate(row)">更新</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <el-dialog custom-class="dialog-wrapper" title="设备更新" destroy-on-close v-model="updateDialog.visible"
         :close-on-click-modal="false" :modal-append-to-body="false">
         <el-form label-width="100px">
            <el-form-item label="选择固件版本:">
               <el-select v-model="updateDialog.selectId" placeholder="请选择固件版本" filterable style="width: 100%;">
                  <el-option v-for="(item, index) in updateDialog.data" :key="index" :label="item.label"
                     :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="版本描述内容:">
               <div>{{ updateDialog.content[updateDialog.selectId] }}</div>
            </el-form-item>
         </el-form>
         <template #footer>
            <el-button @click="updateDialog.visible = false">取消</el-button>
            <el-button type="primary" @click="clickUpdateDone">确认</el-button>
         </template>
      </el-dialog>

   </div>
</template>

<script>
import DeviceStatus from '../Components/DeviceStatus.vue';

export default {
   components: {
      DeviceStatus
   },

   data() {
      return {
         loading: false,
         schoolId: '',
         deviceUid: '',
         upgradeList: [],
         updateDialog: {
            visible: false,
            deviceType: '',
            deviceName: '',
            type: '',
            data: [],
            content: {},
            selectId: '',
         },
      }
   },

   mounted() {
      this.schoolId = this.$util.getUrlParam("schoolId");
      this.deviceUid = this.$util.getUrlParam("uid");
      this.queryUpgradeList();
   },

   methods: {
      // 查询设备版本列表
      queryUpgradeList() {
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/hw/onePc/v290/appUpgrade/list',
            params: { uid: this.deviceUid },
         }).then((result) => {
            if (!result.body.data || JSON.stringify(result.body.data) === '[]') {
               this.upgradeList = []
               return
            }
            this.upgradeList = result.body.data
         }).catch(() => {
            this.upgradeList = []
         }).finally(() => {
            this.loading = false;
         })
      },

      // 查询固件包版本列表
      queryFirmwareList() {
         this.loading = true;
         let params = {
            uid: this.deviceUid,
            deviceType: this.updateDialog.queryType,
         }
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v210/list',
            params: params,
         }).then((result) => {
            if (!result.body.data || JSON.stringify(result.body.data) === '[]') {
               this.updateDialog.data = [];
               this.updateDialog.selectId = '';
               this.$util.errorMsg('暂未查询到固件版本');
               return
            }
            this.updateDialog.data = result.body.data.map((item) => {
               this.updateDialog.content[item.id] = item.content
               return {
                  label: item.versionCode,
                  value: item.id,
               }
            });
            this.updateDialog.selectId = this.updateDialog.data[0].value;
         }).catch(() => {
            this.updateDialog.data = [];
            this.updateDialog.selectId = '';
            this.$util.errorMsg('查询固件版本失败');
         }).finally(() => {
            this.loading = false;
         })
      },

      // 发送更新固件包版本
      sendUpdateFirmware() {
         this.loading = true;
         let param = {
            uid: this.deviceUid,
            deviceType: this.updateDialog.deviceType,
            deviceName: this.updateDialog.deviceName,
            appUpgradeId: this.updateDialog.selectId
         }
         this.$http({
            method: 'post',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v210/update',
            body: param,
         }).then((result) => {
            if (result.body.data === true) {
               this.updateDialog.visible = false;
               this.$util.successMsg('更新成功');
               this.queryUpgradeList();
            } else {
               this.$util.errorMsg(result.body.msg);
            }
         }).catch(() => {
            this.updateDialog.visible = false;
            this.$util.errorMsg('更新失败');
         }).finally(() => {
            this.loading = false;
         })
      },

      // 点击一体机设备更新
      clickUpdate(row) {
         this.updateDialog.queryType = row.deviceType;
         this.updateDialog.deviceType = row.deviceType;
         this.updateDialog.deviceName = row.deviceType;
         this.updateDialog.type = '';
         this.queryFirmwareList();
         this.updateDialog.visible = true;
      },

      // 点击更新弹框确定
      clickUpdateDone() {
         this.sendUpdateFirmware();
      },

   }
}
</script>

<style scoped>
.detail-title {
   font-size: 16px;
   font-weight: 500;
   color: #333333;
}

.title-margin {
   margin: 40px 0px 20px 0px;
}
</style>


// WEBPACK FOOTER //
// EquipmentSitDetail.vue?8402f818